import addDays from "date-fns/addDays"
import subDays from "date-fns/subDays"
import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Form from "src/components/Form"
import { DefaultDatePickerInput } from "src/components/LongFormDatePicker"

const NightViewHeader = ({ date, onDateChange, paths }) => {
  const handlePrevDay = () => onDateChange(subDays(date, 1))
  const handleNextDay = () => onDateChange(addDays(date, 1))

  const handleDatePickerChange = (newDate) => {
    if (newDate) {
      onDateChange(newDate)
    }
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      {/* Date Navigation */}
      <div className="min-w-0 flex-1 sm:min-w-[380px] sm:flex-none">
        <Form.DatePicker
          value={date}
          onChange={handleDatePickerChange}
          dateFormat="eeee, MMMM d, yyyy"
          todayButton="Today"
          customInput={
            <DefaultDatePickerInput
              handleDateBackward={handlePrevDay}
              handleDateForward={handleNextDay}
            />
          }
        />
      </div>

      {/* Action Buttons */}
      <div className="flex items-center gap-2">
        {/* Assignments - icon only on mobile */}
        <div className="sm:hidden">
          <a href={paths.assignments}>
            <Button
              variant="secondary"
              small
              icon="fa-calendar"
              iconStyle="solid"
              iconOnly
              title="Assignments"
            />
          </a>
        </div>
        <div className="hidden sm:block">
          <a href={paths.assignments}>
            <Button
              variant="secondary"
              small
              icon="fa-calendar"
              iconStyle="solid"
            >
              Assignments
            </Button>
          </a>
        </div>
        {/* Waitlist - icon only on mobile */}
        <div className="sm:hidden">
          <a href={paths.waitlist}>
            <Button
              variant="secondary"
              small
              icon="fa-clock"
              iconStyle="solid"
              iconOnly
              title="Waitlist"
            />
          </a>
        </div>
        <div className="hidden sm:block">
          <a href={paths.waitlist}>
            <Button variant="secondary" small icon="fa-clock" iconStyle="solid">
              Waitlist
            </Button>
          </a>
        </div>
      </div>
    </div>
  )
}

NightViewHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onDateChange: PropTypes.func.isRequired,
  paths: PropTypes.shape({
    assignments: PropTypes.string.isRequired,
    waitlist: PropTypes.string.isRequired,
  }).isRequired,
}

export default NightViewHeader
